import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './Button';
import { Input } from './Input';
import { RichTextEditor } from './RichTextEditor';
interface AddCustomerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (customer: {
    customerId: string;
    name: string;
    address: string;
    phone: string;
    email?: string;
    notes: string;
    secondaryContactName?: string;
    secondaryContactPhone?: string;
  }) => void;
  nextCustomerId: string;
}
export function AddCustomerModal({
  isOpen,
  onClose,
  onAdd,
  nextCustomerId
}: AddCustomerModalProps) {
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [notes, setNotes] = useState('');
  const [secondaryContactName, setSecondaryContactName] = useState('');
  const [secondaryContactPhone, setSecondaryContactPhone] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;
    onAdd({
      customerId: nextCustomerId,
      name,
      address,
      phone,
      email: email || undefined,
      notes,
      secondaryContactName: secondaryContactName || undefined,
      secondaryContactPhone: secondaryContactPhone || undefined
    });
    setName('');
    setAddress('');
    setPhone('');
    setEmail('');
    setNotes('');
    setSecondaryContactName('');
    setSecondaryContactPhone('');
    onClose();
  };
  return <AnimatePresence data-id="element-135">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={onClose} data-id="element-136" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        duration: 0.3
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-y-auto" data-id="element-137">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl p-6 my-8" data-id="element-138">
              <div className="flex items-center justify-between mb-6" data-id="element-139">
                <div data-id="element-140">
                  <h2 className="text-2xl font-semibold text-stone-900" data-id="element-141">
                    Tilføj kunde
                  </h2>
                  <p className="text-sm text-stone-500 mt-1" data-id="element-142">
                    Kunde-ID:{' '}
                    <span className="font-medium text-teal-600" data-id="element-143">
                      {nextCustomerId}
                    </span>
                  </p>
                </div>
                <button onClick={onClose} className="text-stone-400 hover:text-stone-600 transition-colors" aria-label="Luk" data-id="element-144">
                  <XIcon className="w-6 h-6" data-id="element-145" />
                </button>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-146">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-147">
                  <Input label="Kundenavn" value={name} onChange={e => setName(e.target.value)} placeholder="Indtast kundenavn" required data-id="element-148" />

                  <Input label="Telefon" value={phone} onChange={e => setPhone(e.target.value)} placeholder="f.eks. +45 12 34 56 78" type="tel" data-id="element-149" />
                </div>

                <Input label="Adresse" value={address} onChange={e => setAddress(e.target.value)} placeholder="Indtast adresse" data-id="element-150" />

                <Input label="Email (valgfri)" value={email} onChange={e => setEmail(e.target.value)} placeholder="kunde@email.dk" type="email" data-id="element-151" />

                <div className="pt-4 border-t border-stone-100" data-id="element-152">
                  <h3 className="text-sm font-medium text-stone-900 mb-3" data-id="element-153">
                    Ekstra kontaktperson (valgfri)
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-154">
                    <Input label="Navn" value={secondaryContactName} onChange={e => setSecondaryContactName(e.target.value)} placeholder="Navn på kontaktperson" data-id="element-155" />
                    <Input label="Telefon" value={secondaryContactPhone} onChange={e => setSecondaryContactPhone(e.target.value)} placeholder="Telefonnummer" type="tel" data-id="element-156" />
                  </div>
                </div>

                <RichTextEditor label="Noter" value={notes} onChange={setNotes} placeholder="Tilføj noter om denne kunde" rows={3} data-id="element-157" />

                <div className="flex gap-3 pt-2" data-id="element-158">
                  <Button type="button" variant="secondary" onClick={onClose} className="flex-1" data-id="element-159">
                    Annuller
                  </Button>
                  <Button type="submit" variant="primary" className="flex-1" data-id="element-160">
                    Tilføj kunde
                  </Button>
                </div>
              </form>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}